import React from 'react';
import { Input } from './input';
import { cn } from '@/lib/utils';

export interface InlineEditInputProps {
  value: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  autoFocus?: boolean;
}

export function InlineEditInput({
  value,
  onChange,
  onSave,
  onCancel,
  placeholder,
  className,
  disabled = false,
  autoFocus = true,
}: InlineEditInputProps) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSave();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      onCancel();
    }
  };

  const handleBlur = () => {
    // Save when clicking outside (blur event)
    onSave();
  };

  return (
    <Input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      autoFocus={autoFocus}
    />
  );
}

export interface InlineEditDisplayProps {
  value: string | null;
  placeholder: string;
  onClick: () => void;
  className?: string;
}

export function InlineEditDisplay({
  value,
  placeholder,
  onClick,
  className,
}: InlineEditDisplayProps) {
  return (
    <div
      className={cn('hover:bg-surface cursor-pointer rounded p-2 transition-colors', className)}
      onClick={onClick}
    >
      {value ? (
        <div className="text-sm">{value}</div>
      ) : (
        <div className="text-foreground text-sm italic">{placeholder}</div>
      )}
    </div>
  );
}
